import { iseeInstance } from '../axiosService'

class PortalVUService {
  async fetchPortals (page = 1, limit = 10) {
    return iseeInstance.get('/portals', {
      params: {
        page,
        limit
      },
      timeout: 30000
    })
  }

  async fetchAllPortals () {
    return iseeInstance.get('/portals', {
      params: {
        all: true
      },
      timeout: 30000
    })
  }

  async fetchCurrPortal (portalName) {
    return iseeInstance.get(`/portals/${portalName}`)
  }

  async fetchLicencesForPortal (portalId) {
    return iseeInstance.get(`/licences/${portalId}`)
  }

  async fetchAllLicences () {
    return iseeInstance.get('/licences/all')
  }

  async createLicencesForPortal (type, count, portalId, expiresAt) {
    return iseeInstance.post('/licences/', {
      type,
      count,
      portalId,
      expiresAt
    })
  }

  async updateLicence (licenceId, type, count, expiresAt, portalId) {
    return iseeInstance.put(`/licences/${licenceId}`, {
      type,
      count,
      expiresAt,
      portalId
    })
  }

  async deleteLicence (licenceId) {
    return iseeInstance.delete(`/licences/${licenceId}`)
  }

  async updateLicenceStatus (licenceId, status) {
    return iseeInstance.patch(`/licences/${licenceId}/status`, {
      status
    })
  }

  async addPortal (
    portalName,
    licenceCount,
    portalType,
    mainPortal,
    portalLocation,
    expiryDate,
    isRecordByDefault,
    isNeverRecord,
    isAgentByDefault,
    defaultNoteTemplate
  ) {
    return iseeInstance.post('/portals', {
      name: portalName,
      licenses: licenceCount,
      type: portalType,
      mainPortal,
      location: portalLocation,
      expiryDate,
      isRecordByDefault,
      isNeverRecord,
      isAgentByDefault,
      defaultNoteTemplate
    })
  }

  async editPortal (
    portalId,
    portalName,
    licenceCount,
    expiryDate,
    isAgentByDefault,
    defaultNoteTemplate
  ) {
    const payload = {
      name: portalName,
      licenses: licenceCount,
      expiryDate
    }
    if (isAgentByDefault !== undefined) payload.isAgentByDefault = isAgentByDefault
    if (defaultNoteTemplate !== undefined) payload.defaultNoteTemplate = defaultNoteTemplate
    return iseeInstance.put('/portals/' + portalId, payload)
  }

  async deletePortal (portalId) {
    return iseeInstance.delete(`/portals/${portalId}`)
  }

  async getActiveCalls () {
    return iseeInstance.get('/sessions')
  }

  async getAllUsers () {
    return iseeInstance.get('/users/all')
  }

  async deleteUser (email, portalName) {
    const data = { email }
    if (portalName) {
      data.portal = portalName
    }
    return iseeInstance.delete('/users/', { data })
  }

  async getTips (portalName, isActive) {
    return iseeInstance.get(
      `/tips/${portalName}${
        isActive !== undefined ? '?isActive=' + isActive : ''
      }`
    )
  }

  async createTip (tip, currentPortalName) {
    return iseeInstance.post('/tips', {
      tip,
      currentPortalName
    })
  }

  async editTip (currTipId, newTip, currentPortalName) {
    return iseeInstance.put('/tips', {
      currTipId,
      newTip,
      currentPortalName
    })
  }

  async getOnlineSockets () {
    return iseeInstance.get('/users/admin/online-sockets')
  }

  async forceDisconnectSocket (socketId) {
    return iseeInstance.post('/users/admin/force-disconnect', { socketId })
  }
}

export default new PortalVUService()
